/**
 * Embedding-based similar-transaction lookup over the diary.
 */
import { EmbeddingIndex } from '../chassis/embeddings.ts';
import type { Transaction } from '../types.ts';

function fingerprint(t: Transaction): string {
  return `${t.merchant_display} ${t.category} ${t.items.slice(0, 5).join(' ')}`;
}

let cached: EmbeddingIndex<Transaction> | null = null;

function getIndex(): EmbeddingIndex<Transaction> {
  if (cached === null) {
    cached = new EmbeddingIndex<Transaction>('hisaab-tx', fingerprint);
  }
  return cached;
}

export async function indexTransactions(txs: Transaction[]): Promise<void> {
  await getIndex().ensureIndexed(txs);
}

export async function findSimilar(tx: Transaction, topK: number = 5): Promise<Array<{ record: Transaction; score: number }>> {
  return getIndex().findSimilar(tx, topK);
}

export function indexSize(): number {
  return getIndex().size();
}
